import type { PnlHierarchyMember } from 'src/components/star-grid/starGridTypes';
import type { ReportParameterOption } from 'src/components/star-grid/reportDefinition.types';

/** One option per member, depth-indented, in hierarchy order.
 *
 * A normal multiselect dropdown cannot nest, so depth is carried in the label: the tree's shape
 * stays readable without the panel-and-grid editor a report's filter bar has no room for. The
 * option's `description` keeps the parent chain so a repeated leaf name is still distinguishable.
 */
export const hierarchyOptions = (members: readonly PnlHierarchyMember[], depth = 0, parents: readonly string[] = []): ReportParameterOption[] =>
  members.flatMap((member) => [
    {
      value: member.id,
      label: `${'  '.repeat(depth)}${member.label}`,
      description: parents.join(' / ')
    },
    ...hierarchyOptions(member.children ?? [], depth + 1, [...parents, member.label])
  ]);

/** Deduped by member id, keeping the first (shallowest) position of a multi-parent member. */
export const uniqueHierarchyOptions = (options: readonly ReportParameterOption[]): ReportParameterOption[] => [
  ...new Map(options.map((option) => [option.value, option])).values()
];
